<template>
  <div>
    <div>
      <div class="row">
        <div class="col-5">
          <h4>
            <span class="md-display-1"> Notificações </span>
          </h4>
        </div>
        <div class="col-2">
          <h4>
            <md-button
              class="md-primary md-raised"
              @click.stop="$router.push({ name: 'NotificacaoNovo' })"
            >
              Cadastrar
            </md-button>
          </h4>
        </div>
        <div class="col-2">
          <md-field>
            <md-select
              id="equipamentos"
              v-model="filtro.acaoEquipamentoId"
              name="equipamentos"
              placeholder="Ação"
              :disabled="loading"
              md-dense
              @md-selected="loadData()"
            >
              <md-option
                v-for="equipamento in filtro.equipamentos"
                :key="equipamento.id"
                :value="equipamento.id"
              >
                {{ equipamento.nome }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="col-2">
          <md-field>
            <md-select
              id="equipamentos"
              v-model="filtro.expressaoEquipamentoId"
              name="equipamentos"
              placeholder="Expressão"
              :disabled="loading"
              md-dense
              @md-selected="loadData()"
            >
              <md-option
                v-for="equipamento in filtro.equipamentos"
                :key="equipamento.id"
                :value="equipamento.id"
              >
                {{ equipamento.nome }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="col-1">
          <md-button
            class="md-icon-button mt-3"
            @click="
              () => {
                filtro.acaoEquipamentoId = null
                filtro.expressaoEquipamentoId = null
              }
            "
          >
            <md-icon class=""> close </md-icon>
          </md-button>
        </div>
      </div>
      <md-divider />
      <br />
    </div>
    <div v-if="loading" class="mt-5" style="text-align: center">
      <md-progress-spinner
        :md-diameter="500"
        :md-stroke="10"
        md-mode="indeterminate"
      />
    </div>
    <div v-if="!loading">
      <md-table>
        <md-table-row>
          <md-table-head>Identificação</md-table-head>
          <md-table-head>Titulo</md-table-head>
          <md-table-head>Dias</md-table-head>
          <md-table-head>Horário</md-table-head>
          <md-table-head>Ativado</md-table-head>
          <md-table-head />
        </md-table-row>
        <md-table-row v-for="notificacao in notificacoes" :key="notificacao.id">
          <md-table-cell>
            <p>
              {{ notificacao.identificacao }}
            </p>
          </md-table-cell>
          <md-table-cell>{{ notificacao.titulo }}</md-table-cell>
          <md-table-cell>{{
            criarStringDias(notificacao.diasParaExecutarNotificacao)
          }}</md-table-cell>
          <md-table-cell>{{
            formataRange(notificacao.horarioExecutarNotificacao) || '-'
          }}</md-table-cell>
          <md-table-cell>
            <md-switch
              v-model="notificacao.ativada"
              @change="
                () =>
                  changeNotificacaoAtivada(notificacao.id, notificacao.ativada)
              "
            />
          </md-table-cell>
          <md-table-cell>
            <router-link
              :to="{
                name: 'NotificacaoEditar',
                params: { localId: localId, notificacaoId: notificacao.id },
              }"
            >
              <md-button type="submit" class="md-primary"> Editar </md-button>
            </router-link>
            <md-button
              type="submit"
              class="md-primary md-accent"
              @click="() => (excluirId = notificacao.id)"
            >
              Remover
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
    <md-dialog-confirm
      :md-active.sync="excluirId"
      md-title="Deseja excluir essa notificação?"
      md-confirm-text="Confirmar"
      md-cancel-text="cancelar"
      @md-cancel="() => (excluirId = null)"
      @md-confirm="excluirNotificacao"
    />
  </div>
</template>

<script>
import { load } from 'three/examples/jsm/libs/opentype.module'

import FiltroRapido from '../../components/FiltroRapido'
import http from '../../utils/http'

export default {
  name: 'NotificacaoIndex',
  components: { FiltroRapido },
  data() {
    return {
      excluirId: null,
      localId: null,
      notificacoes: [],
      loading: true,
      local: null,
      filtro: {
        acaoEquipamentoId: null,
        expressaoEquipamentoId: null,
        equipamentos: [],
      },
    }
  },
  async beforeMount() {
    this.localId = this.$route.params.localId

    this.local = (await http.get(`local/${this.localId}`)).local

    await this.loadData()
  },
  methods: {
    load,
    async loadData() {
      this.loading = true

      await Promise.all([
        http
          .get(`local/${this.localId}/equipamentos`)
          .then((e) => (this.filtro.equipamentos = e.equipamentos)),
        http
          .get(`local/${this.localId}/notificacoes`, {
            acaoEquipamentoId: this.filtro.acaoEquipamentoId,
            expressaoEquipamentoId: this.filtro.expressaoEquipamentoId,
          })
          .then((e) => {
            this.notificacoes = e.notificacoes
            this.loading = false
          }),
      ]).finally(() => (this.loading = false))
    },
    formataRange(data) {
      if (!data) {
        return null
      }

      const { inicio, fim } = data

      return this.removeMinutos(inicio) + ' às ' + this.removeMinutos(fim)
    },
    async changeNotificacaoAtivada(notificacaoId, ativada) {
      await http.put(`notificacao/${notificacaoId}/ativada`, { ativada })
    },
    async excluirNotificacao() {
      await http.delete('notificacao', this.excluirId)

      http.get(`local/${this.localId}/notificacoes`).then((e) => {
        this.notificacoes = e.notificacoes
        this.loading = false
      })
    },
    removeMinutos(data) {
      const [fst, snd] = data.split(':')

      return `${fst}:${snd}`
    },
    criarStringDias(listaDias) {
      if (listaDias.length === 0) {
        return '-'
      }

      const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']

      return listaDias.map((e) => dias[e]).reduce((acc, e) => acc + '-' + e)
    },
  },
}
</script>

<style scoped></style>
